import { createAction } from 'redux-actions'

import * as constants from './constants'

export const setPlan = createAction(constants.SET_PLAN)
export const setCoupon = createAction(constants.SET_COUPON)

export const fetchDeal = createAction(constants.FETCH_DEAL)
export const fetchDealSuccess = createAction(constants.FETCH_DEAL_SUCCESS)
export const fetchDealPending = createAction(constants.FETCH_DEAL_PENDING)
export const fetchDealFailed = createAction(constants.FETCH_DEAL_FAILED)

export const activateDeal = createAction(constants.ACTIVATE_DEAL)
export const activateDealSuccess = createAction(constants.ACTIVATE_DEAL_SUCCESS)
export const activateDealPending = createAction(constants.ACTIVATE_DEAL_PENDING)
export const activateDealFailed = createAction(constants.ACTIVATE_DEAL_FAILED)



// WEBPACK FOOTER //
// ./src/modules/billing/actions.js